module.exports = __webpack_public_path__ + "img/2.1.447e9e8b.svg";